import React, { Fragment, useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { connect } from "react-redux";
import { setEnableMobileMenu } from "../../reducers/ThemeOptions";
import {
  OzetAnalizleriNav,
  IsEmirleriNav,
  CarNav,
  LastikDepoNav,
  UrunHizmetNav,
  AracHareketleriNav,
  TanimlarNav,
  SmsSablonlariNav,
  SuperAdminNav,
  OneriNav,
} from "./NavItems";

const SubMenu = ({ item, toggleMobileSidebar }) => {
  const [isSubMenuOpen, setIsSubMenuOpen] = useState(false);
  const location = useLocation();

  const toggleSubMenu = (e) => {
    if (!item.to || item.content) {
      e.preventDefault();
      e.stopPropagation();
      setIsSubMenuOpen(!isSubMenuOpen);
    } else if (item.to && !item.external) {
      toggleMobileSidebar();
    }
  };

  const hasSubmenu = item.content && item.content.length > 0;
  
  // Determine if the parent or any child is active
  const isActive = location.pathname === item.to || 
    (hasSubmenu && item.content.some(child => child.to === location.pathname));

  const LinkComponent = item.external ? 'a' : Link;
  const linkProps = item.external 
    ? { href: item.to, target: "_blank", rel: "noopener noreferrer" }
    : { to: item.to || "#" };

  return (
    <li className={`metismenu-item ${isActive ? "active" : ""}`}>
      <LinkComponent
        {...linkProps}
        className={`metismenu-link ${isActive ? "active" : ""}`}
        onClick={toggleSubMenu}
      >
        <i className={`metismenu-icon ${item.icon}`} />
        {item.label}
        {hasSubmenu && (
          <i className={`metismenu-state-icon pe-7s-angle-${isSubMenuOpen ? 'up' : 'down'}`} />
        )}
      </LinkComponent>
      {hasSubmenu && (
        <ul className={`metismenu-container ${isSubMenuOpen ? "visible" : ""}`}>
          {item.content.map((child, i) => (
            <li key={i} className="metismenu-item">
              <Link
                to={child.to}
                className={`metismenu-link ${
                  location.pathname === child.to ? "active" : ""
                }`}
                onClick={toggleMobileSidebar}
              >
                {child.label}
              </Link>
            </li>
          ))}
        </ul>
      )}
    </li>
  );
};

const menuGroups = [
  { label: "Yönetim Paneli", items: SuperAdminNav, adminOnly: true },
  { label: "Operasyon", items: [...CarNav, ...AracHareketleriNav, ...IsEmirleriNav] },
  { label: "Lastik Depo", items: LastikDepoNav },
  { label: "Raporlama", items: OzetAnalizleriNav },
  { label: "Tanımlar", items: [...TanimlarNav, ...SmsSablonlariNav, ...UrunHizmetNav] },
  { label: "Müşteri", items: OneriNav },
];

const groupContainsPath = (group, pathname) =>
  group.items.some((item) => item.to === pathname || item.content?.some((child) => child.to === pathname));

const Nav = ({ enableMobileMenu, setEnableMobileMenu }) => {
  const location = useLocation();
  const toggleMobileSidebar = () => {
    if (enableMobileMenu) {
      setEnableMobileMenu(false);
    }
  };

  const kullanici = JSON.parse(localStorage.getItem("pl_kullanici") || "{}");
  const isSuperAdmin = kullanici?.rol === "SuperAdmin";
  const visibleGroups = menuGroups.filter((group) => !group.adminOnly || isSuperAdmin);
  const activeGroup = visibleGroups.find((group) => groupContainsPath(group, location.pathname))?.label || "Operasyon";
  const [openGroup, setOpenGroup] = useState(activeGroup);

  useEffect(() => {
    setOpenGroup(activeGroup);
  }, [activeGroup]);

  const renderMenu = (items) =>
    items.map((item, i) => (
      <SubMenu key={i} item={item} toggleMobileSidebar={toggleMobileSidebar} />
    ));

  return (
    <Fragment>
      <div className="vertical-nav-menu">
        {visibleGroups.map((group) => {
          const isOpen = openGroup === group.label;

          return (
            <section className="sidebar-nav-group" key={group.label}>
              <button
                type="button"
                className={`app-sidebar__heading sidebar-nav-group__toggle${group.adminOnly ? " sidebar-nav-group__toggle--admin" : ""}`}
                aria-expanded={isOpen}
                onClick={() => setOpenGroup(isOpen ? null : group.label)}
              >
                <span>{group.label}</span>
                <i className={`pe-7s-angle-${isOpen ? "up" : "down"}`} aria-hidden="true" />
              </button>
              {isOpen && <ul className="metismenu-container">{renderMenu(group.items)}</ul>}
            </section>
          );
        })}
      </div>
    </Fragment>
  );
};

const mapStateToProps = (state) => ({
  enableMobileMenu: state.ThemeOptions.enableMobileMenu,
});

const mapDispatchToProps = (dispatch) => ({
  setEnableMobileMenu: (enable) => dispatch(setEnableMobileMenu(enable)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Nav);
